import React, { useState } from 'react';
import {
	useLazyDocumentationFilesQuery,
	useLazyPrescriptionsQuery,
} from '../../../graphql/graphql';

export default function usePresecriptions() {
	const [getPrescriptionsQuery, { data, isLoading }] =
		useLazyPrescriptionsQuery();
	const [page, setPage] = useState(1);
	const getPrescriptions = (filter: object) => {
		getPrescriptionsQuery({
			...filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getPrescriptions, getNextPage, data, isLoading, page, setPage };
}
